import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../utils/api';
import { toast } from 'sonner';

const AdminPaymentsTab = () => {
  const [payments, setPayments] = useState([]);
  const [status, setStatus] = useState('');

  const load = async () => {
    try { const res = await adminAPI.getPayments({ status, limit: 300 }); setPayments(res.data); }
    catch (e) { toast.error('Failed to load payments'); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const refund = async (p) => {
    if (p.status === 'refunded') return;
    const note = window.prompt('Refund note (visible only to admins):', '');
    if (note === null) return;
    if (!window.confirm('Mark this payment as refunded? Actual refund must be processed in Razorpay dashboard.')) return;
    try { await adminAPI.refundPayment(p.payment_id, note); toast.success('Marked refunded'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };

  const totalCaptured = payments.filter((p) => p.status === 'captured').reduce((s, p) => s + (p.amount || 0), 0) / 100;

  return (
    <div className="space-y-3" data-testid="admin-payments-tab">
      <div className="bg-white rounded-xl p-3 border border-gray-100 flex flex-col sm:flex-row gap-2 items-stretch sm:items-center">
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="payments-status-filter"
          className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm">
          <option value="">All statuses</option>
          <option value="captured">Captured</option>
          <option value="created">Created (unpaid)</option>
          <option value="failed">Failed</option>
          <option value="refunded">Refunded</option>
        </select>
        <p className="text-xs sm:text-sm text-[#6B7280] sm:ml-auto">
          {payments.length} payments · Captured total: <strong className="text-[#10B981]">₹{totalCaptured.toLocaleString()}</strong>
        </p>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 overflow-x-auto">
        <table className="w-full text-xs sm:text-sm">
          <thead className="bg-[#f8f9fa] text-left">
            <tr>
              <th className="px-3 py-2">Order / Payment ID</th>
              <th className="px-3 py-2 hidden sm:table-cell">User</th>
              <th className="px-3 py-2">Amount</th>
              <th className="px-3 py-2">Status</th>
              <th className="px-3 py-2 hidden md:table-cell">When</th>
              <th className="px-3 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.payment_id} className="border-t border-gray-100 hover:bg-[#fafafa]" data-testid={`payment-row-${p.payment_id}`}>
                <td className="px-3 py-2">
                  <p className="font-mono text-[10px] sm:text-[11px] text-[#4B5563]">{p.razorpay_payment_id || p.razorpay_order_id || p.payment_id}</p>
                  <p className="text-[10px] text-[#9CA3AF]">{p.purpose || '—'}</p>
                </td>
                <td className="px-3 py-2 hidden sm:table-cell text-[#4B5563] truncate max-w-[140px]">{p.user_id}</td>
                <td className="px-3 py-2 font-bold text-[#0A0B10]">₹{((p.amount || 0) / 100).toLocaleString()}</td>
                <td className="px-3 py-2">
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold ${
                    p.status === 'captured' ? 'bg-green-50 text-green-600' :
                    p.status === 'refunded' ? 'bg-amber-50 text-amber-700' :
                    p.status === 'failed' ? 'bg-red-50 text-red-600' :
                    'bg-gray-100 text-gray-600'}`}>{(p.status || '').toUpperCase()}</span>
                </td>
                <td className="px-3 py-2 hidden md:table-cell text-[#6B7280] text-[11px]">{(p.captured_at || p.created_at || '').slice(0, 16).replace('T', ' ')}</td>
                <td className="px-3 py-2 text-right">
                  {p.status === 'captured' && (
                    <button onClick={() => refund(p)} data-testid={`refund-${p.payment_id}`}
                      className="px-2 py-1 rounded bg-amber-50 text-amber-700 hover:bg-amber-700 hover:text-white text-[10px] font-bold">
                      Mark Refunded
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {payments.length === 0 && (
              <tr><td colSpan={6} className="px-3 py-8 text-center text-[#9CA3AF]">No payments</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPaymentsTab;
